var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NcButton',{attrs:{"type":"secondary"},on:{"click":_vm.onNewNote}},[_c('PlusIcon',{attrs:{"slot":"icon","size":20},slot:"icon"}),_vm._v("\n\t"+_vm._s(_vm.t('notes', 'Create a sample note with Markdown'))+"\n")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }